import React from 'react'
import { Box, Tooltip, TooltipProps } from '@ritualco/jutsu'
import { QuestionIcon } from 'assets/Icons'

export type QuestionTooltipProps = TooltipProps & {
  label: React.ReactNode
}

export const QuestionTooltip = ({
  label,
  children,
  ...tooltipProps
}: QuestionTooltipProps) => (
  <Tooltip
    {...tooltipProps}
    variant="dark"
    label={label}
    placement={'right-end'}
  >
    <Box as="span">
      {children}
      <QuestionIcon boxSize={4} color="grayscale.tertiary" ml={1} />
    </Box>
  </Tooltip>
)
